import { MoonStars, Sun } from '@phosphor-icons/react';
import { AnimatePresence, motion } from 'motion/react';
import { useThemeToggle } from '../hooks/use-theme-toggle';

export function ThemeToggle() {
  const { mode, label, toggle } = useThemeToggle();

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className="relative inline-flex size-11 items-center justify-center overflow-hidden rounded-field text-ink hover:bg-ink/5"
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={mode}
          initial={{ y: 14, opacity: 0, rotate: -40 }}
          animate={{ y: 0, opacity: 1, rotate: 0 }}
          exit={{ y: -14, opacity: 0, rotate: 40 }}
          transition={{ duration: 0.22 }}
          className="inline-flex"
        >
          {mode === 'dark' ? <MoonStars size={22} weight="duotone" /> : <Sun size={22} weight="duotone" />}
        </motion.span>
      </AnimatePresence>
    </button>
  );
}
